import { render, staticRenderFns } from "./SACTip.vue?vue&type=template&id=3102a13e&scoped=true"
import script from "./SACTip.vue?vue&type=script&lang=js"
export * from "./SACTip.vue?vue&type=script&lang=js"
import style0 from "./SACTip.vue?vue&type=style&index=0&id=3102a13e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3102a13e",
  null
  
)

export default component.exports